export default {
    topics: [
        {
            title: ' address ',
            href: 's-nms-address.html',
            attributes: { 'data-id': 's-nms-address' },
            menu: { hasChildren: false },
            tocID: 's-nms-address-d66e2103',
            next: 's-nms-address-d66e2103',
        },
        {
            title: ' asset ',
            href: 's-nms-asset.html',
            attributes: { 'data-id': 's-nms-asset' },
            menu: { hasChildren: false },
            tocID: 's-nms-asset-d66e2119',
            next: 's-nms-asset-d66e2119',
        },
        {
            title: ' budget ',
            href: 's-nms-budget.html',
            attributes: { 'data-id': 's-nms-budget' },
            menu: { hasChildren: false },
            tocID: 's-nms-budget-d66e2183',
            next: 's-nms-budget-d66e2183',
        },
        {
            title: ' centralCatalog ',
            href: 's-nms-centralCatalog.html',
            attributes: { 'data-id': 's-nms-centralCatalog' },
            menu: { hasChildren: false },
            tocID: 's-nms-centralCatalog-d66e2239',
            next: 's-nms-centralCatalog-d66e2239',
        },
        {
            title: ' cusResource ',
            href: 's-nms-cusResource.html',
            attributes: { 'data-id': 's-nms-cusResource' },
            menu: { hasChildren: false },
            tocID: 's-nms-cusResource-d66e2279',
            next: 's-nms-cusResource-d66e2279',
        },
        {
            title: ' delivery ',
            href: 's-nms-delivery.html',
            attributes: { 'data-id': 's-nms-delivery' },
            menu: { hasChildren: false },
            tocID: 's-nms-delivery-d66e2311',
            next: 's-nms-delivery-d66e2311',
        },
        {
            title: ' deliveryMapping ',
            href: 's-nms-deliveryMapping.html',
            attributes: { 'data-id': 's-nms-deliveryMapping' },
            menu: { hasChildren: false },
            tocID: 's-nms-deliveryMapping-d66e2812',
            topics: [],
        },
        {
            title: ' deliveryOperation ',
            href: 's-nms-deliveryOperation.html',
            attributes: { 'data-id': 's-nms-deliveryOperation' },
            menu: { hasChildren: false },
            tocID: 's-nms-deliveryOperation-d66e2820',
            next: 's-nms-deliveryOperation-d66e2820',
        },
        {
            title: ' eventHisto ',
            href: 's-nms-eventHisto.html',
            attributes: { 'data-id': 's-nms-eventHisto' },
            menu: { hasChildren: false },
            tocID: 's-nms-eventHisto-d66e2844',
            next: 's-nms-eventHisto-d66e2844',
        },
        {
            title: ' extAccount ',
            href: 's-nms-extAccount.html',
            attributes: { 'data-id': 's-nms-extAccount' },
            menu: { hasChildren: false },
            tocID: 's-nms-extAccount-d66e2876',
            next: 's-nms-extAccount-d66e2876',
        },
        {
            title: ' gdprRequest ',
            href: 's-nms-gdprRequest.html',
            attributes: { 'data-id': 's-nms-gdprRequest' },
            menu: { hasChildren: false },
            tocID: 's-nms-gdprRequest-d66e2916',
            next: 's-nms-gdprRequest-d66e2916',
        },
        {
            title: ' privacyRequest ',
            href: 's-nms-privacyRequest.html',
            attributes: { 'data-id': 's-nms-privacyRequest' },
            menu: { hasChildren: false },
            tocID: 's-nms-privacyRequest-d66e2949',
            next: 's-nms-privacyRequest-d66e2949',
        },
        {
            title: ' group ',
            href: 's-nms-group.html',
            attributes: { 'data-id': 's-nms-group' },
            menu: { hasChildren: false },
            tocID: 's-nms-group-d66e2981',
            next: 's-nms-group-d66e2981',
        },
        {
            title: ' includeView ',
            href: 's-nms-includeView.html',
            attributes: { 'data-id': 's-nms-includeView' },
            menu: { hasChildren: false },
            tocID: 's-nms-includeView-d66e3045',
            topics: [],
        },
        {
            title: ' interaction ',
            href: 's-nms-interaction.html',
            attributes: { 'data-id': 's-nms-interaction' },
            menu: { hasChildren: false },
            tocID: 's-nms-interaction-d66e3053',
            topics: [],
        },
        {
            title: ' localOrder ',
            href: 's-nms-localOrder.html',
            attributes: { 'data-id': 's-nms-localOrder' },
            menu: { hasChildren: false },
            tocID: 's-nms-localOrder-d66e3061',
            next: 's-nms-localOrder-d66e3061',
        },
        {
            title: ' localValidationLog ',
            href: 's-nms-localValidationLog.html',
            attributes: { 'data-id': 's-nms-localValidationLog' },
            menu: { hasChildren: false },
            tocID: 's-nms-localValidationLog-d66e3149',
            next: 's-nms-localValidationLog-d66e3149',
        },
        {
            title: ' localValidationTask ',
            href: 's-nms-localValidationTask.html',
            attributes: { 'data-id': 's-nms-localValidationTask' },
            menu: { hasChildren: false },
            tocID: 's-nms-localValidationTask-d66e3165',
            next: 's-nms-localValidationTask-d66e3165',
        },
        {
            title: ' mobileApp ',
            href: 's-nms-mobileApp.html',
            attributes: { 'data-id': 's-nms-mobileApp' },
            menu: { hasChildren: false },
            tocID: 's-nms-mobileApp-d66e3181',
            next: 's-nms-mobileApp-d66e3181',
        },
        {
            title: ' newsgroup ',
            href: 's-nms-newsgroup.html',
            attributes: { 'data-id': 's-nms-newsgroup' },
            menu: { hasChildren: false },
            tocID: 's-nms-newsgroup-d66e3237',
            next: 's-nms-newsgroup-d66e3237',
        },
        {
            title: ' offer ',
            href: 's-nms-offer.html',
            attributes: { 'data-id': 's-nms-offer' },
            menu: { hasChildren: false },
            tocID: 's-nms-offer-d66e3261',
            next: 's-nms-offer-d66e3261',
        },
        {
            title: ' offerCategory ',
            href: 's-nms-offerCategory.html',
            attributes: { 'data-id': 's-nms-offerCategory' },
            menu: { hasChildren: false },
            tocID: 's-nms-offerCategory-d66e3333',
            next: 's-nms-offerCategory-d66e3333',
        },
        {
            title: ' offerSpace ',
            href: 's-nms-offerSpace.html',
            attributes: { 'data-id': 's-nms-offerSpace' },
            menu: { hasChildren: false },
            tocID: 's-nms-offerSpace-d66e3366',
            next: 's-nms-offerSpace-d66e3366',
        },
        {
            title: ' operation ',
            href: 's-nms-operation.html',
            attributes: { 'data-id': 's-nms-operation' },
            menu: { hasChildren: false },
            tocID: 's-nms-operation-d66e3406',
            next: 's-nms-operation-d66e3406',
        },
        {
            title: ' predictiveModel ',
            href: 's-nms-predictiveModel.html',
            attributes: { 'data-id': 's-nms-predictiveModel' },
            menu: { hasChildren: false },
            tocID: 's-nms-predictiveModel-d66e3559',
            next: 's-nms-predictiveModel-d66e3559',
        },
        {
            title: ' purl ',
            href: 's-nms-purl.html',
            attributes: { 'data-id': 's-nms-purl' },
            menu: { hasChildren: false },
            tocID: 's-nms-purl-d66e3591',
            next: 's-nms-purl-d66e3591',
        },
        {
            title: ' recipient ',
            href: 's-nms-recipient.html',
            attributes: { 'data-id': 's-nms-recipient' },
            menu: { hasChildren: false },
            tocID: 's-nms-recipient-d66e3623',
            next: 's-nms-recipient-d66e3623',
        },
        {
            title: ' remaHypothesis ',
            href: 's-nms-remaHypothesis.html',
            attributes: { 'data-id': 's-nms-remaHypothesis' },
            menu: { hasChildren: false },
            tocID: 's-nms-remaHypothesis-d66e3663',
            next: 's-nms-remaHypothesis-d66e3663',
        },
        {
            title: ' remoteTracking ',
            href: 's-nms-remoteTracking.html',
            attributes: { 'data-id': 's-nms-remoteTracking' },
            menu: { hasChildren: false },
            tocID: 's-nms-remoteTracking-d66e3703',
            next: 's-nms-remoteTracking-d66e3703',
        },
        {
            title: ' rtEvent ',
            href: 's-nms-rtEvent.html',
            attributes: { 'data-id': 's-nms-rtEvent' },
            menu: { hasChildren: false },
            tocID: 's-nms-rtEvent-d66e3775',
            next: 's-nms-rtEvent-d66e3775',
        },
        {
            title: ' seedMember ',
            href: 's-nms-seedMember.html',
            attributes: { 'data-id': 's-nms-seedMember' },
            menu: { hasChildren: false },
            tocID: 's-nms-seedMember-d66e3799',
            next: 's-nms-seedMember-d66e3799',
        },
        {
            title: ' simulation ',
            href: 's-nms-simulation.html',
            attributes: { 'data-id': 's-nms-simulation' },
            menu: { hasChildren: false },
            tocID: 's-nms-simulation-d66e3815',
            next: 's-nms-simulation-d66e3815',
        },
        {
            title: ' stock ',
            href: 's-nms-stock.html',
            attributes: { 'data-id': 's-nms-stock' },
            menu: { hasChildren: false },
            tocID: 's-nms-stock-d66e3895',
            next: 's-nms-stock-d66e3895',
        },
        {
            title: ' subscription ',
            href: 's-nms-subscription.html',
            attributes: { 'data-id': 's-nms-subscription' },
            menu: { hasChildren: false },
            tocID: 's-nms-subscription-d66e3912',
            next: 's-nms-subscription-d66e3912',
        },
        {
            title: ' supplier ',
            href: 's-nms-supplier.html',
            attributes: { 'data-id': 's-nms-supplier' },
            menu: { hasChildren: false },
            tocID: 's-nms-supplier-d66e3960',
            next: 's-nms-supplier-d66e3960',
        },
        {
            title: ' task ',
            href: 's-nms-task.html',
            attributes: { 'data-id': 's-nms-task' },
            menu: { hasChildren: false },
            tocID: 's-nms-task-d66e3984',
            next: 's-nms-task-d66e3984',
        },
        {
            title: ' trackingUrl ',
            href: 's-nms-trackingUrl.html',
            attributes: { 'data-id': 's-nms-trackingUrl' },
            menu: { hasChildren: false },
            tocID: 's-nms-trackingUrl-d66e4048',
            next: 's-nms-trackingUrl-d66e4048',
        },
        {
            title: ' typologyRule ',
            href: 's-nms-typologyRule.html',
            attributes: { 'data-id': 's-nms-typologyRule' },
            menu: { hasChildren: false },
            tocID: 's-nms-typologyRule-d66e4104',
            next: 's-nms-typologyRule-d66e4104',
        },
        {
            title: ' visitor ',
            href: 's-nms-visitor.html',
            attributes: { 'data-id': 's-nms-visitor' },
            menu: { hasChildren: false },
            tocID: 's-nms-visitor-d66e4120',
            next: 's-nms-visitor-d66e4120',
        },
        {
            title: ' webApp ',
            href: 's-nms-webApp.html',
            attributes: { 'data-id': 's-nms-webApp' },
            menu: { hasChildren: false },
            tocID: 's-nms-webApp-d66e4136',
            next: 's-nms-webApp-d66e4136',
        },
        {
            title: ' webForm ',
            href: 's-nms-webForm.html',
            attributes: { 'data-id': 's-nms-webForm' },
            menu: { hasChildren: false },
            tocID: 's-nms-webForm-d66e4241',
            next: 's-nms-webForm-d66e4241',
        },
        {
            title: ' workflow ',
            href: 's-nms-workflow.html',
            attributes: { 'data-id': 's-nms-workflow' },
            menu: { hasChildren: false },
            tocID: 's-nms-workflow-d66e4289',
            next: 's-nms-workflow-d66e4289',
        },
    ],
};

